'use client';

import { Divider } from '@heroui/react';
import { manrope } from '@trwl/app/fonts';
import { APP_STORE_LINK, CURRENT_YEAR } from '@trwl/constants';
import { Container } from '@trwl/layout';
import { LocationPin, Phone } from '@trwl/shared/ui/icons';
import { $footerLinks, loadFooterMenu } from '@trwl/store';
import { $addresses, loadAddresses } from '@trwl/store/addresses';
import { $contacts, loadContacts } from '@trwl/store/contacts';
import { $phones, loadPhones } from '@trwl/store/phones';
import { yandexMapLink } from '@trwl/util';
import cn from 'classnames';
import { useUnit } from 'effector-react';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export const Footer = () => {
  const pathname = usePathname();
  const footerLinks = useUnit($footerLinks);
  const addresses = useUnit($addresses);
  const phones = useUnit($phones);
  const contacts = useUnit($contacts);

  useEffect(() => {
    loadFooterMenu();
    loadAddresses();
    loadPhones();
    loadContacts();
  }, []);

  return (
    <>
      <div className={'h-[100px]'} />
      <footer
        className={cn(
          'w-full border-t-[2px] z-10 border-t-[#ECECEC] bg-[#FAFAFA]',
          manrope.className,
          pathname !== '/' && 'hidden lg:block',
        )}
      >
        <Container>
          <div className="py-[40px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 h-full w-full items-start justify-between gap-8">
            <div className="flex flex-col gap-[20px] justify-center items-start text-[#B1B1B1] text-[12px] lg:text-[14] font-[500]">
              <div>Социальные сети</div>
              <div className="flex flex-col gap-[15px]">
                {contacts.map((item) => (
                  <Link
                    target={'_blank'}
                    key={item.id}
                    href={item.attributes?.url || '#'}
                    className="flex flex-row gap-[15px] justify-start items-center font-[500] text-[12px] lg:text-[14px] text-[#6C6C6C]"
                  >
                    <Image
                      width={20}
                      height={20}
                      src={item.attributes?.icon?.data?.attributes?.url || '#'}
                      alt={
                        item.attributes?.icon?.data?.attributes
                          ?.alternativeText || ''
                      }
                    />{' '}
                    {item.attributes?.title}
                  </Link>
                ))}
              </div>
              <div>Контактный телефон</div>
              <div className="flex flex-col gap-[15px]">
                {phones.map((item) => (
                  <Link
                    target={'_blank'}
                    key={item.id}
                    href={
                      item.attributes?.phone
                        ? `tel:${item.attributes.phone}`
                        : '#'
                    }
                    className="flex flex-row gap-[15px] justify-start items-center font-[500] text-[12px] lg:text-[14px] text-[#6C6C6C]"
                  >
                    <Phone />
                    {item.attributes?.phone}
                  </Link>
                ))}

                <Divider />

                <Link
                  target={'_blank'}
                  href={'mailto:support@trwl.store'}
                  className="flex flex-row gap-[15px] justify-start items-center font-[500] text-[12px] lg:text-[14px] text-[#6C6C6C]"
                >
                  support@trwl.store
                </Link>
              </div>
            </div>

            <div
              className={
                'flex flex-col gap-[20px] justify-center items-start text-[#B1B1B1] text-[12px] lg:text-[14] font-[500] md:col-span-2'
              }
            >
              <div>Информация</div>
              <div className="flex flex-col gap-[15px]">
                {footerLinks.map((item) => (
                  <Link
                    target={'_blank'}
                    key={item.id}
                    href={item.attributes?.link || '#'}
                    className="flex flex-row gap-[15px] justify-start items-center font-[500] text-[12px] lg:text-[14px] text-[#6C6C6C]"
                  >
                    {item.attributes?.title}
                  </Link>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-[20px] justify-center items-start text-[#B1B1B1] text-[12px] lg:text-[14] font-[500] -order-1 lg:order-5">
              <div>Приложение trwl</div>
              <div className="flex flex-row items-center gap-[10px] max-h-[50px]">
                <Link href={APP_STORE_LINK} target="_blank">
                  <Image
                    src="https://storage.yandexcloud.net/trwl-static/site/download-on-app-store.svg"
                    width="150"
                    height="50"
                    alt="download-on-app-store"
                  />
                </Link>
                {/*NOTE <Link href={PLAY_MARKET_LINK} target="_blank">
                  <Image
                    src="https://storage.yandexcloud.net/trwl-static/site/download-on-play-market.png"
                    width="170"
                    height="50"
                    alt="download-on-app-store"
                  />
                </Link>*/}
              </div>
            </div>
          </div>
        </Container>

        <div className={'mx-auto font-light text-sm w-full text-center mt-3'}>
          © 2021-{CURRENT_YEAR}. TRWL.STORE
        </div>
      </footer>
    </>
  );
};
